import { render, staticRenderFns } from "./ProductFleecePage.vue?vue&type=template&id=6f936d08&scoped=true&"
import script from "./ProductFleecePage.vue?vue&type=script&lang=js&"
export * from "./ProductFleecePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f936d08",
  null
  
)

export default component.exports